// extracted by mini-css-extract-plugin
export default {"appGallery":"_1meg7o9"};